import React from 'react'
import {useMutation} from '@tanstack/react-query'; 

import { useAlert } from 'context/alert';
import { deleteArea } from 'services/area';

const Delete = ({ item, onClose }) => {
    const { showAlert } = useAlert();
    const onSuccess = (res) => {
        const refetchArea = true;
        showAlert("Area deleted successfully!", "danger");
        onClose(refetchArea)
    }

    const onError = (err) => {
        const errorDetail = err?.response?.data?.detail;
        const message =
          typeof errorDetail === "string"
            ? errorDetail
            : errorDetail?.msg || JSON.stringify(errorDetail);
    
        showAlert(message, "danger");
    };

    const { mutate: deleteAreaMutate } = useMutation({
        mutationFn: deleteArea,
        onSuccess,
        onError,
    });

    const onConfirm = () => {
        deleteAreaMutate(item)
    }
    return (
        <>
            <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
            >
                Cancel
            </button>
            <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                    onConfirm();
                }}
            >
                Delete
            </button>
        </>
    )
}

export default Delete